"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var semver = require("semver");

var call_credentials_1 = require("./call-credentials");

var channel_credentials_1 = require("./channel-credentials");

var client_1 = require("./client");

exports.Client = client_1.Client;

var constants_1 = require("./constants");

exports.logVerbosity = constants_1.LogVerbosity;
exports.status = constants_1.Status;

var logging = require("./logging");

var make_client_1 = require("./make-client");

exports.loadPackageDefinition = make_client_1.loadPackageDefinition;
exports.makeClientConstructor = make_client_1.makeClientConstructor;
exports.makeGenericClientConstructor = make_client_1.makeClientConstructor;

var metadata_1 = require("./metadata");

exports.Metadata = metadata_1.Metadata;

var status_builder_1 = require("./status-builder");

exports.StatusBuilder = status_builder_1.StatusBuilder;
var supportedNodeVersions = '^8.11.2 || >=9.4';

if (!semver.satisfies(process.version, supportedNodeVersions)) {
  throw new Error("@grpc/grpc-js only works on Node ".concat(supportedNodeVersions));
}

function mixin() {
  var result = {};

  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }

  for (var _i = 0; _i < sources.length; _i++) {
    var source = sources[_i];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.getOwnPropertyNames(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var propName = _step.value;
        var property = source[propName]; // tslint:disable-line no-any

        if (typeof property === 'function') {
          result[propName] = property;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return result;
}
/**** Client Credentials ****/
// Using assign only copies enumerable properties, which is what we want


exports.credentials = mixin({
  /**
   * Create a gRPC credential from a Google credential object.
   * @param googleCredentials The authentication client to use.
   * @return The resulting CallCredentials object.
   */
  createFromGoogleCredential: function createFromGoogleCredential(googleCredentials) {
    return call_credentials_1.CallCredentials.createFromMetadataGenerator(function (options, callback) {
      googleCredentials.getRequestMetadata(options.service_url, function (err, headers) {
        if (err) {
          callback(err);
          return;
        }

        var metadata = new metadata_1.Metadata();
        metadata.add('authorization', headers.Authorization);
        callback(null, metadata);
      });
    });
  },

  /**
   * Combine a ChannelCredentials with any number of CallCredentials into a
   * single ChannelCredentials object.
   * @param channelCredentials The ChannelCredentials object.
   * @param callCredentials Any number of CallCredentials objects.
   * @return The resulting ChannelCredentials object.
   */
  combineChannelCredentials: function combineChannelCredentials(channelCredentials) {
    for (var _len2 = arguments.length, callCredentials = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      callCredentials[_key2 - 1] = arguments[_key2];
    }

    return callCredentials.reduce(function (acc, other) {
      return acc.compose(other);
    }, channelCredentials);
  },

  /**
   * Combine any number of CallCredentials into a single CallCredentials
   * object.
   * @param first The first CallCredentials object.
   * @param additional Any number of additional CallCredentials objects.
   * @return The resulting CallCredentials object.
   */
  combineCallCredentials: function combineCallCredentials(first) {
    for (var _len3 = arguments.length, additional = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      additional[_key3 - 1] = arguments[_key3];
    }

    return additional.reduce(function (acc, other) {
      return acc.compose(other);
    }, first);
  }
}, channel_credentials_1.ChannelCredentials, call_credentials_1.CallCredentials);
/**
 * Close a Client object.
 * @param client The client to close.
 */

exports.closeClient = function (client) {
  return client.close();
};

exports.waitForClientReady = function (client, deadline, callback) {
  return client.waitForReady(deadline, callback);
};
/**** Unimplemented function stubs ****/

/* tslint:disable:no-any variable-name */


exports.loadObject = function (value, options) {
  throw new Error('Not available in this library. Use @grpc/proto-loader and loadPackageDefinition instead');
};

exports.load = function (filename, format, options) {
  throw new Error('Not available in this library. Use @grpc/proto-loader and loadPackageDefinition instead');
};

exports.setLogger = function (logger) {
  logging.setLogger(logger);
};

exports.setLogVerbosity = function (verbosity) {
  logging.setLoggerVerbosity(verbosity);
};

exports.Server = function (options) {
  throw new Error('Not yet implemented');
};

exports.ServerCredentials = {
  createSsl: function createSsl(rootCerts, keyCertPairs, checkClientCertificate) {
    throw new Error('Not yet implemented');
  },
  createInsecure: function createInsecure() {
    throw new Error('Not yet implemented');
  }
};

exports.getClientChannel = function (client) {
  return client_1.Client.prototype.getChannel.call(client);
};

exports.ListenerBuilder = function () {
  throw new Error('Not yet implemented');
};

exports.InterceptorBuilder = function () {
  throw new Error('Not yet implemented');
};

exports.InterceptingCall = function () {
  throw new Error('Not yet implemented');
};